import { render, staticRenderFns } from "./about-comp.vue?vue&type=template&id=e1a2859e&scoped=true&"
import script from "./about-comp.vue?vue&type=script&lang=js&"
export * from "./about-comp.vue?vue&type=script&lang=js&"
import style0 from "./about-comp.vue?vue&type=style&index=0&id=e1a2859e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a2859e",
  null
  
)

export default component.exports